import script from "./SectionPlaylist.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionPlaylist.vue?vue&type=script&setup=true&lang=ts"

import "./SectionPlaylist.vue?vue&type=style&index=0&id=6ef4b7a0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef4b7a0"]])

export default __exports__